import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { messagesApiClient } from "./client"
import {
  IJiraIssuesPayload,
  IOpenIssuesPayload,
} from "@/models/jiraIssue/jiraIssue.types"
import { IssueStatuses, IssueSystems } from "@/api/soMessages/constants"

const openIssuesPayload = {
  status: IssueStatuses,
  system: IssueSystems,
}

export const SoMessagesQueries = createQueryKeyStore({
  getJiraIssueById: {
    issue: (issueId: string) => ({
      queryKey: [issueId],
      queryFn: () => messagesApiClient.get(`jira/issue/${issueId}`),
      enabled: !!issueId,
    }),
  },
  openIssuesByPriority: {
    issues: (payload: IOpenIssuesPayload) => ({
      queryKey: [payload.priority],
      queryFn: () =>
        messagesApiClient.post("jira/project/10046/issues", {
          ...openIssuesPayload,
          ...payload,
        }),
    }),
  },
  getJiraIssues: {
    issues: (payload: IJiraIssuesPayload) => ({
      queryKey: [payload],
      queryFn: () =>
        messagesApiClient.post("jira/project/10046/issues", {
          ...payload,
        }),
    }),
  },
})

export type SoMessagesQueryKeys = inferQueryKeyStore<typeof SoMessagesQueries>
